import Icon from '../components/Icon.vue'

Icon.register({
  table: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h416zM224 416v-96h-160v96h160zM224 256v-96h-160v96h160zM448 416v-96h-160v96h160zM448 256v-96h-160v96h160z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/table.js
// module id = 1976
// module chunks = 0